
// Unified collection for all properties
export const PROPERTIES_COLLECTION = 'coleccion_inmuebles';
export const INMUEBLES_ALIADOS_COLLECTION = 'coleccion_inmuebles';
export const BROKERS_PROPERTIES_COLLECTION = 'coleccion_inmuebles';

export const APP_CONFIG_COLLECTION = 'app_config';
export const USERS_COLLECTION = 'users';
export const INMOBILIARIAS_COLLECTION = 'inmobiliarias';

// Map short codes to the unified collection (legacy support)
export const shortCodeMap: Record<string, string> = {
    c: PROPERTIES_COLLECTION,
    a: INMUEBLES_ALIADOS_COLLECTION,
    b: BROKERS_PROPERTIES_COLLECTION
};
